import { defineComponent, h, PropType } from 'vue';
import './index.scss';
import styles from './index.module.scss';
import { next_tick } from '@vaaas/fpts/timing';

type Variant =
    undefined
    | 'primary'
    | 'clear'
    | 'outlined';

type ButtonType =
    'submit'
    | 'reset'
    | 'button';

export const Button = defineComponent({
    props: {
        variant: {
            required: false,
            type: String as PropType<Variant>,
            default: undefined,
        },

        block: {
            required: false,
            type: Boolean,
            default: false,
        },

        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },

        href: {
            required: false,
            type: String,
        },

        in_new_tab: {
            required: false,
            type: Boolean,
            default: false,
        },

        type: {
            required: false,
            type: String as PropType<ButtonType>,
            default: 'button',
        }
    },

    emits: {
        click: (x: MouseEvent) => true,
    },

    methods: {
        onClick(x: MouseEvent) {
            if (this.recently_touched) {
                this.$el.focus();
                next_tick(() => this.$emit('click', x));
            } else this.$emit('click', x);
        },

        onTouch() { this.last_touched = Date.now(); },
    },

    computed: {
        recently_touched(): boolean {
            return Date.now() - this.last_touched <= 250;
        },

        tag_name() {
            if (this.href) return 'a';
            else return 'button';
        },
    },

    data() {
        return { last_touched: 0 };
    },

    render() {
        return h(this.tag_name, {
            type: this.type,
            class: {
                btn: true,
                'btn--clear': this.variant === 'clear',
                'btn--outlined': this.variant === 'outlined',
                disabled: this.disabled,
                [styles.button]: true,
                [styles.primary]: this.variant === 'primary',
                [styles.block]: this.block,
            },
            tabindex: '0',
            disabled: this.disabled,
            onClick: this.onClick,
            onTouchstart: this.onTouch,
            href: this.href,
            target: this.in_new_tab ? '_blank' : null,
        }, this.$slots.default && this.$slots.default());
    },
});
